/**
 * Creates a URL from a string and return undefined if there is any error
 */
export const buildURL = (url: string): URL | undefined => {
  try {
    return new URL(url);
  } catch (e) {
    console.warn(e);
    return undefined;
  }
};
